module.exports = __webpack_public_path__ + "img/virtual_live.98faff0e.png";